/**
 * Детермінований індекс кольору тла аватара з імені/назви (feature-034 §10.2).
 *
 * Стабільний, НЕ криптографічний — суто декоративний: те саме імʼя завжди дає
 * той самий колір (консистентність ініціали↔колір; той самий вхід, що й
 * `getInitials`). Повертає index у діапазоні `[0, AVATAR_PALETTE_SIZE)`, який
 * консюмер мапить на пару токенів `--avatar-bg-{n}` / `--avatar-fg-{n}`.
 *
 * `trim` + `toLocaleLowerCase` нормалізують регістр/пробіли (стабільна кирилиця);
 * `Array.from` коректно ріже surrogate-пари (емодзі). Порожнє/`null`/`undefined`
 * → `0` (стабільний дефолт; у компоненті колір застосовується лише за наявності
 * ініціалів, тож порожнє імʼя кольору не отримує).
 */
export const AVATAR_PALETTE_SIZE = 6;

export function getAvatarPalette(name?: string | null): number {
  const base = (name ?? "").trim().toLocaleLowerCase();
  const hash = Array.from(base).reduce(
    (acc, ch) => acc + (ch.codePointAt(0) ?? 0),
    0,
  );
  return hash % AVATAR_PALETTE_SIZE;
}
